
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"18","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M5 0v1H0v2h1v13a2 2 0 002 2h10a2 2 0 002-2V3h1V1h-5V0H5zM3 3h10v13H3V3zm2 2v9h2V5H5zm4 0v9h2V5H9z","fill":"#9A0A0A"}})])
          )
        }
      }
    